'use client';
import { Button, ControlledInput, Typography } from 'components';
import { THEME_TASK_QUERY_STATUS } from 'constants/status';
import { CommentsFilterEnum, TaskQueryStatusEnum } from 'gql/graphql';
import useOptionsPairLanguages from 'hooks/useOptionsPairLanguages';
import { CloseIcon, SearchIcon } from 'lib/svgs/Icons';
import { useTranslations } from 'next-intl';
import { FC } from 'react';
import { Control } from 'react-hook-form';
import { KeysEnum } from 'types/KeysEnum';
import { TasksInProgressForm } from '../page';

interface IFiltersTasks {
  control: Control<TasksInProgressForm>;
  onClear?: () => void;
  filtersAdded?: boolean;
}

const FiltersTasks: FC<IFiltersTasks> = ({ control, filtersAdded, onClear }) => {
  const t = useTranslations();

  const { optionsLanguages } = useOptionsPairLanguages();

  const optionsComments = [
    { label: t(`translation.index.comments.any`), value: undefined },
    {
      label: t(`translation.index.comments.${CommentsFilterEnum.With}` as any),
      value: CommentsFilterEnum.With
    },
    {
      label: t(`translation.index.comments.${CommentsFilterEnum.Without}` as any),
      value: CommentsFilterEnum.Without
    },

    {
      label: t(`translation.index.comments.${CommentsFilterEnum.Pending}` as any),
      value: CommentsFilterEnum.Pending
    }
  ];

  const checkboxes = [
    {
      label: t(`tasks_filters.${TaskQueryStatusEnum.Initialized}` as any),
      icon: (
        <span className="scale-[0.8]">
          {THEME_TASK_QUERY_STATUS[TaskQueryStatusEnum.Initialized]?.icon}
        </span>
      ),
      value: TaskQueryStatusEnum.Initialized
    },
    {
      label: t(`tasks_filters.${TaskQueryStatusEnum.Active}` as any),
      icon: (
        <span className="scale-[0.8]">
          {THEME_TASK_QUERY_STATUS[TaskQueryStatusEnum.Active]?.icon}
        </span>
      ),
      value: TaskQueryStatusEnum.Active
    },
    {
      label: t(`tasks_filters.${TaskQueryStatusEnum.ClientReview}` as any),
      icon: (
        <span className="scale-[0.8]">
          {THEME_TASK_QUERY_STATUS[TaskQueryStatusEnum.ClientReview]?.icon}
        </span>
      ),
      value: TaskQueryStatusEnum.ClientReview
    },
    {
      label: t(`tasks_filters.${TaskQueryStatusEnum.Correcting}` as any),
      icon: (
        <span className="scale-[0.8]">
          {THEME_TASK_QUERY_STATUS[TaskQueryStatusEnum.Correcting]?.icon}
        </span>
      ),
      value: TaskQueryStatusEnum.Correcting
    }
  ];

  return (
    <div className="mb-10 w-full">
      <div className="mb-3 flex items-center justify-between">
        <Typography variant="medium1" className={'text-tertiary-100 '}>
          {t('tasks_filters.filters')}
        </Typography>
        {filtersAdded && (
          <Button
            size="small"
            variant="text"
            color="secondary"
            label={t('translation.filters_translation.clear_all')}
            className="!m-0 !h-7 w-fit rounded-full !px-2 !shadow-none"
            classNameTypography="text-xs !m-0"
            endAdornment={<CloseIcon className=" scale-[0.7]" />}
            onClick={onClear}
          />
        )}
      </div>
      <ControlledInput
        control={control}
        label={t('tasks_filters.tr_id')}
        placeholder={t('tasks_filters.e_g_tr_id')}
        type="text"
        endAdornment={<SearchIcon />}
        name={KeysEnum.TranslationRequestVersion}
        className="!w-full"
        classNameParent="!w-full mt-4"
      />
      <ControlledInput
        control={control}
        label={t('tasks_filters.task_id')}
        placeholder={t('tasks_filters.e_g_task_id')}
        type="text"
        endAdornment={<SearchIcon />}
        name={KeysEnum.TaskId}
        className="!w-full"
        classNameParent="!w-full mt-4"
      />
      <ControlledInput
        control={control}
        label={t('tasks_filters.language_pair')}
        type="select"
        name={KeysEnum.Languages}
        classNameParent="pt-3"
        options={optionsLanguages}
      />
      <ControlledInput
        control={control}
        label={t('tasks_filters.comments')}
        type="select"
        name={KeysEnum.Comments}
        classNameParent="pt-3"
        options={optionsComments}
      />
      <ControlledInput
        control={control}
        label={t('tasks_filters.filter_by')}
        type="filter"
        name={KeysEnum.Status}
        classNameParent="pt-3"
        checkboxes={checkboxes}
      />
    </div>
  );
};
export default FiltersTasks;
